import { Injectable } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

@Injectable()
export class CustomDateAdapter extends MomentDateAdapter {

  override getFirstDayOfWeek(): number {
    return 0; // 0 = Domingo, 1 = Lunes, etc.
  }

  override getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
    return super.getDayOfWeekNames('short').map(day => day.charAt(0).toUpperCase());
  }
}
